@custom-media --mobile (max-width: 768px);

.row {
  display: flex;
  margin: 1em 0;

  @media (--mobile) {
    flex-wrap: wrap;
  }
}

.questionRow {
  margin: 0;
  padding: 0.5em 0 0.5em 0.5em;
}

.question {
  flex-grow: 3;
  flex-basis: 0;

  @media (--mobile) {
    margin-bottom: 1em;
    flex-basis: 100%;
  }
}

.option {
  flex-grow: 1;
  flex-basis: 0;
  padding: 0 0.5em;

  @media (--mobile) {
    font-size: 0.75em;

    & input[type="radio"] + label,
    & input[type="checkbox"] + label {
      padding-left: 0;
    }
  }
}

/**
 * Extra space after last row
*/
.row:last-of-type:not(:only-of-type) {
  padding-bottom: 2.5em;
}

.submitButton {
  margin-left: 1em;
  border-radius: 0;

  &:disabled {
    background-color: var(--darkSilver);
  }
}

.separator {
  margin-top: 2rem;
}
